// extracted by mini-css-extract-plugin
module.exports = {"description":"ContrastChecker--description--2e0rw","link":"ContrastChecker--link--3SYyI","icon":"ContrastChecker--icon--ddJvW"};